var _style, _path, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "1147.5 -20 400 400",
    style: {
      enableBackground: "new 1147.5 -20 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#353535;}\r\n\t.st1{fill:#0ACF83;}\r\n\t.st2{fill:#A259FF;}\r\n\t.st3{fill:#F24E1E;}\r\n\t.st4{fill:#FF7262;}\r\n\t.st5{fill:#1ABCFE;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1487,371.5h-279c-28.6,0-52-23.4-52-52v-279c0-28.6,23.4-52,52-52h279c28.6,0,52,23.4,52,52v279 C1539,348.1,1515.6,371.5,1487,371.5z"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Figma.logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    className: "st1",
    d: "M1307.5,300c22.1,0,40-17.9,40-40v-40h-40c-22.1,0-40,17.9-40,40 C1267.5,282.1,1285.4,300,1307.5,300z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    className: "st2",
    d: "M1267.5,180c0-22.1,17.9-40,40-40h40v80h-40C1285.4,220,1267.5,202.1,1267.5,180z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill_1_",
    className: "st3",
    d: "M1267.5,100c0-22.1,17.9-40,40-40h40v80h-40C1285.4,140,1267.5,122.1,1267.5,100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    className: "st4",
    d: "M1347.5,60h40c22.1,0,40,17.9,40,40s-17.9,40-40,40h-40V60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    className: "st5",
    d: "M1427.5,180c0,22.1-17.9,40-40,40s-40-17.9-40-40c0-22.1,17.9-40,40-40 S1427.5,157.9,1427.5,180z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.b41192dd72e95c2f1810a25a4ef9ec28.svg";
export { ForwardRef as ReactComponent };